import { createSlice } from '@reduxjs/toolkit';
const initialPanelData = {
  'Pre Onboarding': {
    items: [
      { heading: 'User Invite Link', description: 'User Invite Link validity' },
      { heading: 'Preonboarding mail cc configration', description: 'Settings for the automatic approval notification sent to internal users and the successful operation confirmation mail to the candidate.' },
      { heading: 'Approval mail configration', description: 'User Invite Link validity' },
    ],
  },
  'Support': {
    items: [
      { heading: 'Support Config', description: 'config keys and their values' },
      { heading: 'Assignment for category', description: 'Assignment for the support category' },
    ],
  },
  'Offer Letter': {
    items: [
      { heading: 'Title', description: 'description...' },
    ],
  },
  'Offboarding': {
    items: [
      { heading: 'Title', description: 'description...' },
    ],
  },
};
const getInitialState = () => {
  const state = {};
  for (const [key, value] of Object.entries(initialPanelData)) {
    state[key] = { ...value, searchTerm: '' };
  }
  return state;
};

export const panelsSlice = createSlice({
  name: 'panels',
  initialState: getInitialState(),
  reducers: {
    setSearchTerm: (state, action) => {
      const { panelName, term } = action.payload;
      if (state[panelName]) {
        state[panelName].searchTerm = term;
      }
    },

  },
});

export const { setSearchTerm } = panelsSlice.actions;

export default panelsSlice.reducer;